import { render } from "./TrainingSectionInfoBlocks.vue?vue&type=template&id=039043cf&scoped=true"
import script from "./TrainingSectionInfoBlocks.vue?vue&type=script&lang=js"
export * from "./TrainingSectionInfoBlocks.vue?vue&type=script&lang=js"

import "./TrainingSectionInfoBlocks.vue?vue&type=style&index=0&id=039043cf&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039043cf"]])

export default __exports__